import React from 'react';
import Toast from './Toast';
import styles from './ToastContainer.module.css';

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className={styles.container} aria-live="polite" aria-atomic="true">
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          type={toast.type}
          message={toast.message}
          duration={toast.duration}
          onClose={removeToast}
        />
      ))}
    </div>
  );
};

export default ToastContainer;

